import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { SeatPriceSummary, useSeatPrice } from 'features/iam/components/seats/add-seat-dialog';
import { BillingDetailsForm, BillingDetailsFormHandle } from 'features/subscription/components/billing-details-form';
import { PlanSeats } from 'features/subscription/utils/seat-pools';

type AddUserPaymentStepProps = {
  name: string;
  email: string;
  plan: PlanSeats;
  /** The seat count the plan moves to once this person is invited. */
  quantity: number;
  /** The price of that seat, as the parent already checked it. */
  price: ReturnType<typeof useSeatPrice>;
  /** Pay and send invite saves the billing details through this before paying. */
  billingRef: RefObject<BillingDetailsFormHandle>;
};

/**
 * Second step of an invite that buys a seat while the billing details are missing: the seat price
 * and the billing form. The parent's Pay and send invite saves the form, then invites and pays.
 */
export const AddUserPaymentStep = ({ name, email, plan, quantity, price, billingRef }: AddUserPaymentStepProps) => {
  const { t } = useTranslation();

  // Anything other than missing billing details (a refused price, a blocker) shows as before.
  const isOnlyBillingMissing = price.needsBilling && !price.problem && price.blockers.length === 0;
  if (!isOnlyBillingMissing) {
    return <SeatPriceSummary entry={plan} quantity={quantity} />;
  }

  return (
    <div className="flex flex-col gap-4">
      {/* <div className="divide-y rounded-lg border px-4 text-sm">
        <div className="flex justify-between gap-4 py-2.5">
          <span className="text-muted-foreground">{t('INVITING', 'Inviting')}</span>
          <span className="min-w-0 truncate text-right font-medium">
            {name} <span className="font-normal text-muted-foreground">({email})</span>
          </span>
        </div>
      </div> */}
      <BillingDetailsForm ref={billingRef} hideActions />
    </div>
  );
};
